// React
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// Style
import "../../styles/menu/PaymentStyle.scss";
// Components
import Dial from "../../components/common/Dial";
// Recoil
import { cartState, orderState, paymentData } from "../../atom/menu";
import { useRecoilState, useRecoilValue } from "recoil";

function PaymentCash() {
  // 현금 결제 화면

  const navigate = useNavigate();
  // Recoil State
  const cartData = useRecoilValue(cartState);
  const [payment, setPayment] = useRecoilState(paymentData);
  // useState
  const [isPopup, setIsPopup] = useState(false);
  const [isRecallPopup, setIsRecallPopup] = useState(false);
  const [isINGPopup, setINGPopup] = useState(false);
  const [payType, setPayType] = useState(false);
  // true : 개인 / false : 사업자
  const [phoneNumber, setPhoneNumber] = useState("");
  const [CompanyNumber, setCompanyNumber] = useState("");
  const [disabled, setDisabled] = useState<boolean>(true);

  // Function
  useEffect(() => {
    // 현금영수증 휴대폰번호 입력 정책
    // 휴대폰 번호는 11자리로 고정
    // 휴대폰 번호 8자 이상 입력 안되게 처리
    // 010- 까지는 고정텍스트 변경 불가
    // 11자리 이하 입력시 다음단계 진행버튼 비활성화
    if (phoneNumber.length > 8) {
      setPhoneNumber(phoneNumber.slice(0, 8));
    }
    if (phoneNumber.length === 8) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [phoneNumber]);

  useEffect(() => {
    // 현금영수증 사업자번호 입력 정책
    // 사업자번호 10자 이상 입력 안되게 처리
    // 3자리-2자리-5자리
    // 10자리 이하 입력시 다음단계 진행버튼 비활성화
    if (CompanyNumber.length > 10) {
      setCompanyNumber(CompanyNumber.slice(0, 10));
    }
    if (CompanyNumber.length === 10) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [CompanyNumber]);

  const setPayTypeEvent = (payType: string) => {
    const prev = { ...payment, payType: payType };
    setPayment(prev);
  };

  function calcTotalAmount() {
    // 총액 계산
    if (cartData) {
      let amt = 0 as number;
      let option = 0 as number;
      cartData.reduce((acc, cur) => {
        if (cur.option) {
          cur.option.reduce((acc2, cur2) => {
            option = acc2 + cur2.price * cur2.ea;
            return option;
          }, option);
          amt = acc + (cur.price + option) * cur.ea;
        } else {
          amt = acc + cur.price * cur.ea;
        }
        return amt;
      }, amt);
      let total = amt as number;
      return total;
    } else {
      return 0;
    }
  }
  return (
    <>
      <div className='payment-cash-wrap'>
        <img
          className='absolute-logo'
          src={"/assets/images/menu/logo.png"}
          alt='vd company logo'
          style={{ width: 158 }}
        />
        <div className='flex row'>
          <div className='payment-cash-left'>
            <div className='TO-title-2 text-color-gray-3'>
              현금 영수증을 발급하시겠습니까?
              <br />({calcTotalAmount()?.toLocaleString()} 원 결제 예정)
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 36 }}>
              <div
                className='payment-cash-type-select TO-button-2 text-color-gray'
                onClick={() => {
                  setPayType(true);
                }}
              >
                {payType ? (
                  <img
                    src={"/assets/images/menu/radio_on.png"}
                    alt='소득공제용 (개인) 선택'
                  />
                ) : (
                  <img
                    src={"/assets/images/menu/radio_off.png"}
                    alt='소득공제용 (개인) 미선택'
                  />
                )}
                소득공제용 (개인)
              </div>
              <div
                className='payment-cash-type-select TO-button-2 text-color-gray'
                onClick={() => {
                  setPayType(false);
                }}
              >
                {!payType ? (
                  <img
                    src={"/assets/images/menu/radio_on.png"}
                    alt='지출증빙용 (사업자) 선택'
                  />
                ) : (
                  <img
                    src={"/assets/images/menu/radio_off.png"}
                    alt='지출증빙용 (사업자) 미선택'
                  />
                )}
                지출증빙용 (사업자)
              </div>
            </div>
            <div className='flex h-auto'>
              <div
                className='basic-btn white TO-button-1 text-color-gray pointer'
                onClick={() => {
                  navigate("/menu/order/payment");
                }}
              >
                이전으로
              </div>
              <div
                className='basic-btn no-bg TO-button-1 pointer'
                onClick={() => {
                  setPayTypeEvent("cash");
                  setIsPopup(true);
                }}
              >
                결제만하기
              </div>
            </div>
          </div>
          <div className='payment-cash-right'>
            <div
              className='T40B'
              style={{ marginTop: 66, marginBottom: 24, height: 92 }}
            >
              {payType &&
                (phoneNumber.length > 4
                  ? `010-${phoneNumber.slice(0, 4)}-${phoneNumber.slice(4)}`
                  : "010-" + phoneNumber.slice(0, 4))}
              {!payType &&
                (CompanyNumber.length < 4
                  ? `${CompanyNumber}`
                  : CompanyNumber.length < 6
                  ? `${CompanyNumber.slice(0, 3)}-${CompanyNumber.slice(3, 5)}`
                  : `${CompanyNumber.slice(0, 3)}-${CompanyNumber.slice(
                      3,
                      5
                    )}-${CompanyNumber.slice(5)}`)}
              {payType && phoneNumber.length > 0 ? (
                <img
                  src={"/assets/images/menu/delete.svg"}
                  alt='delete'
                  onClick={() => {
                    setPhoneNumber("");
                  }}
                  style={{ marginLeft: 16 }}
                />
              ) : !payType && CompanyNumber.length > 0 ? (
                <img
                  src={"/assets/images/menu/delete.svg"}
                  alt='delete'
                  onClick={() => {
                    setCompanyNumber("");
                  }}
                  style={{ marginLeft: 16 }}
                />
              ) : null}
            </div>
            <div className='number-pad-wrap'>
              {payType ? (
                <Dial
                  type={"phone"}
                  value={phoneNumber}
                  action={setPhoneNumber}
                />
              ) : (
                <Dial
                  type={"phone"}
                  value={CompanyNumber}
                  action={setCompanyNumber}
                />
              )}
            </div>
            {disabled ? (
              <div
                className='basic-btn TO-button-1 red red-disabled'
                style={{ marginTop: 16, minWidth: "100%" }}
                onClick={() => {
                  setPayTypeEvent("cash");
                  setIsPopup(true);
                }}
              >
                발급하기
              </div>
            ) : (
              <div
                className='basic-btn TO-button-1 red pointer'
                style={{ marginTop: 16, minWidth: "100%" }}
                onClick={() => {
                  setPayTypeEvent("cash");
                  setIsPopup(true);
                }}
              >
                발급하기
              </div>
            )}
          </div>
        </div>
      </div>
      {isPopup && (
        <div className='menu-popup-bg'>
          <div className='flex col center' style={{ padding: 40, gap: 64 }}>
            <div
              className='TO-title-1 text-color-gray-3'
              style={{ textAlign: "center" }}
            >
              직원이 오고 있습니다
              <br />
              현금 {calcTotalAmount()?.toLocaleString()} 원을 준비해주세요
            </div>
            <div className='menu-intro-button'>
              <div
                className='basic-btn white TO-button-1 pointer'
                style={{ maxWidth: 309 }}
                onClick={() => {
                  navigate("/menu/order/payment");
                }}
              >
                다른 결제수단
              </div>
              <div
                className='basic-btn TO-button-1 pointer'
                style={{ maxWidth: 324 }}
                onClick={() => {
                  setIsRecallPopup(true);
                  setIsPopup(false);
                }}
              >
                직원 호출
              </div>
            </div>
          </div>
        </div>
      )}
      {isRecallPopup && (
        <div className='menu-popup-bg'>
          <div className='flex col center' style={{ padding: 40, gap: 16 }}>
            <div
              className='TO-title-1 text-color-gray-3'
              style={{ textAlign: "center" }}
            >
              직원을 다시 호출했습니다
              <br />
              현금 {calcTotalAmount()?.toLocaleString()} 원을 준비해주세요
            </div>
            <div className='menu-intro-button'>
              <div
                className='basic-btn white TO-button-1 pointer'
                style={{ maxWidth: 309 }}
                onClick={() => {
                  navigate("/menu/order/payment");
                }}
              >
                다른 결제수단
              </div>
              <div
                className='basic-btn TO-button-1 pointer'
                style={{ maxWidth: 324 }}
                onClick={() => {
                  navigate("/menu/order/payment/success");
                }}
              >
                직원 호출
              </div>
            </div>
          </div>
        </div>
      )}
      {isINGPopup && (
        <div className='menu-popup-bg'>
          <div
            className='menu-popup-inner-wrap'
            style={{ height: "calc(100% - 420px)" }}
          >
            <div className='flex col center' style={{ padding: 40, gap: 16 }}>
              <div className='T38B'>직원이 결제하고 있어요</div>
              <div
                className='T26M'
                style={{ width: 490, textAlign: "center", color: "#636363" }}
              >
                직원이 결제를 마칠 때까지 잠시만 기다려주세요
              </div>
            </div>
            <div className='menu-intro-button'>
              <div
                className='basic-btn T34B pointer'
                onClick={() => {
                  navigate("/");
                }}
              >
                확인
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
export default PaymentCash;
